module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "profileFoodDiary"
    }
  }, [_c('mu-card', {
    attrs: {
      "id": "diary"
    }
  }, [_c('mu-card-header', {
    staticClass: "headerTitle"
  }, [_c('mu-float-button', {
    staticClass: "direction back",
    attrs: {
      "icon": "chevron_left",
      "mini": "",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        return _vm.filterDiaryByDay('back')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title",
    domProps: {
      "textContent": _vm._s(_vm.formatDate(_vm.date, 'dddd, MMMM Do YYYY'))
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title mobileDate",
    domProps: {
      "textContent": _vm._s(_vm.formatDate(_vm.date, 'MMM Do YY'))
    }
  }), _vm._v(" "), _c('mu-float-button', {
    staticClass: "direction next",
    attrs: {
      "icon": "chevron_right",
      "mini": "",
      "disabled": _vm.isLoading || _vm.isToday
    },
    on: {
      "click": function($event) {
        return _vm.filterDiaryByDay('next')
      }
    }
  })], 1), _vm._v(" "), (_vm.isLoading) ? _c('mu-content-block', {
    staticClass: "loader"
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 40
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.hasFoods) ? _c('div', {
    staticClass: "tabs"
  }, [_c('mu-tabs', {
    attrs: {
      "value": _vm.activeTab
    },
    on: {
      "change": _vm.setActiveTab
    }
  }, _vm._l((_vm.tabs), function(tab, tabindex) {
    return _c('mu-tab', {
      key: ("tab-" + tabindex),
      attrs: {
        "value": tab.label,
        "title": tab.label
      }
    })
  }), 1), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _vm._l((_vm.tabs), function(tab, tabindex) {
    return (_vm.activeTab === tab.label) ? _c('food-dairy-tab', {
      key: ("tab-" + tabindex),
      attrs: {
        "userId": _vm.userId,
        "tab": tab.label,
        "foods": _vm.filterDiaryBy('meal_types', tab.label),
        "recipes": _vm.filterRecipeDiaryBy('meal_types', tab.label),
        "totals": _vm.filterDiaryBy('totals', tab.label)
      },
      on: {
        "onDelete": _vm.onDeleteFood
      }
    }) : _vm._e()
  })], 2) : _vm._e(), _vm._v(" "), (!_vm.isLoading && !_vm.hasFoods) ? _c('div', {
    staticClass: "noFoods"
  }, [_c('p', [_vm._v("No foods have been added for this day.")])]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-328b01fa","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profile/FoodDiary/FoodDiary.vue
// module id = 3668
// module chunks = 1